module.exports = __webpack_public_path__ + "img/phone.5f3b84b7.svg";